import { Search } from "@replicate/ui";

interface SiteSearchProps {
  authState: "authenticated" | "anonymous";
  params?: {
    limit: number;
  };
  portal?: boolean;
}

export function SiteSearch({
  authState,
  params = { limit: 50 },
  portal = true,
}: SiteSearchProps) {
  return (
    <div className="w-full max-w-lg">
      <Search params={params} authState={authState} portal={portal} />
    </div>
  );
}
